import { selectBuildingDecorationConstructionDone } from "../selectors/selectBuildingDecorationConstructionDone";
import { createPathFocusBuildingMaxLevel } from "./createPathFocusBuildingMaxLevel";
export var pathFocusDecorationBuildingMaxLevel = function (action, state$, deps) {
    return createPathFocusBuildingMaxLevel(function () {
        return selectBuildingDecorationConstructionDone(state$.value);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/pathFocusDecorationBuildingMaxLevel.ts
// module id = 2369
// module chunks = 3